import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["testId", "isLeftSidebarCollapsed"];
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { B100, B200 } from '@atlaskit/theme/colors';
import { GRAB_AREA_LINE_SELECTOR, GRAB_AREA_SELECTOR } from '../../common/constants';
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */
var varLineColor = '--ds-line';
var grabAreaStyles = css({
  width: 24,
  height: '100%',
  padding: 0,
  backgroundColor: 'transparent',
  border: 0,
  cursor: 'ew-resize',
  '&::-moz-focus-inner': {
    border: 0
  },
  ':focus': {
    outline: 0
  },
  ':enabled': {
    ':hover': _defineProperty({}, varLineColor, "var(--ds-border-selected, ".concat(B100, ")")),
    ':active, :focus': _defineProperty({}, varLineColor, "var(--ds-border-selected, ".concat(B200, ")"))
  }
});
var grabAreaCollapsedStyles = css({
  padding: 0,
  backgroundColor: 'transparent',
  border: 0,
  cursor: 'default'
});
var lineStyles = css({
  display: 'block',
  width: 2,
  height: '100%',
  backgroundColor: "var(".concat(varLineColor, ")"),
  transition: 'background-color 200ms'
});
var grabAreaLineSelector = _defineProperty({}, GRAB_AREA_LINE_SELECTOR, true);
var grabAreaSelector = _defineProperty({}, GRAB_AREA_SELECTOR, true);
// TODO: Consider allowing this to be controlled using arrow keys
var GrabArea = function GrabArea(_ref) {
  var testId = _ref.testId,
    isLeftSidebarCollapsed = _ref.isLeftSidebarCollapsed,
    rest = _objectWithoutProperties(_ref, _excluded);
  return jsx("button", _extends({}, grabAreaSelector, {
    "data-testid": testId,
    type: "button",
    css: [grabAreaStyles, isLeftSidebarCollapsed && grabAreaCollapsedStyles]
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, rest), jsx("span", _extends({
    css: lineStyles
  }, grabAreaLineSelector)));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default GrabArea;